import { Card as MuiCard, styled } from '@mui/joy';

export const Card = styled(MuiCard)`
  background-color: rgb(255, 255, 255);
  }
`;
